import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponentsModule } from '../shared-components.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { phoneMask, phoneMaskPrefix, ValidationPatterns } from 'app/modules/core/constants/core.constants';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-request-phone-popup',
  imports: [CommonModule, SharedComponentsModule],
  templateUrl: './request-phone-popup.component.html',
  styleUrls: ['./request-phone-popup.component.scss'],
  standalone: true
})
export class RequestPhonePopupComponent implements OnInit {
  readonly _dialog: MatDialogRef<RequestPhonePopupComponent> = inject(MatDialogRef<RequestPhonePopupComponent>);
  private readonly data: any = inject(MAT_DIALOG_DATA);

  phoneMask = phoneMask;
  phoneMaskPrefix = phoneMaskPrefix;
  paterns = ValidationPatterns;

  // Used to determine whether the popup is used to enroll 2FA or resolve 2FA request;

  confirmAction: (phone: string | null) => void;
  cancelAction: () => void;

  ngOnInit(): void {
    if (this.data) {
      this.confirmAction = this.data?.confirmAction || null;
      this.cancelAction = this.data?.cancelAction || null;
    }
  }

  contactNumber: FormControl = new FormControl(null, Validators.required);

  closeDialog() {
    if (this.cancelAction) {
      this.cancelAction();
    } else {
      this.confirmAction(null);
    }

    this._dialog.close();
  }

  //return input.replace(/[\s-]/g, '');

  proceed() {
    this.confirmAction(this.contactNumber.value.replace(/[\s-]/g, ''));
    this._dialog.close();
  }
}
